import React, { useContext } from 'react'
import { AlertProps } from '@mui/material'
import { AccountingStyleForm } from '../../settings/AccountingStyleForm'
import { FortnoxContext } from '../../../context/FortnoxContext'
import { OrgType } from '../../../graphql/generated'
import { AppDataContext } from '../../../context/AppDataContext'

interface Props {
  setSnackbar: React.Dispatch<
    React.SetStateAction<Pick<AlertProps, 'children' | 'severity'> | null>
  >
  goToNextStep: () => void
}
export function AccountingStyleStep({
  goToNextStep,
  setSnackbar,
}: Props): React.JSX.Element {
  const { organisation } = React.useContext(AppDataContext)

  const { getData } = useContext(FortnoxContext)

  const onSuccess = () => {
    // start the processing job
    if (organisation.orgType === OrgType.Fortnox) {
      getData()
    }
    goToNextStep()
  }

  return <AccountingStyleForm setSnackbar={setSnackbar} onSuccess={onSuccess} />
}
